import { render, staticRenderFns } from "./ModalOtherLoanNew.vue?vue&type=template&id=636f854d&"
import script from "./ModalOtherLoanNew.vue?vue&type=script&lang=js&"
export * from "./ModalOtherLoanNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports